module.exports = __webpack_public_path__ + "static/img/balz808-663-37083.d3f53f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/balz808-663-37083.jpg
// module id = NpHd
// module chunks = 0